export const ROUTE = {
  root: '',
  login: 'login',
  createAccount: 'create-account',
  signUp: 'sign-up',
  terms: 'terms',
  toc: 'toc',
  imprint: 'imprint',
  teams: 'teams',
  projects: 'projects',
  models: 'models',
  tasks: 'tasks',
  members: 'members',
  tasksManager: 'task-manager',
  embedded: 'embedded', //used in url as route segment, not queryparam
} as const;

export const ROUTE_DATA = {
  matomoSegments: 'matomoSegments',
} as const;

// Centralized Matomo labels map. Use `MATOMO_LABELS[ROUTE.<key>]` in route
export const MATOMO_LABELS = {
  [ROUTE.teams]: ['Teams'],
  [ROUTE.projects]: ['Projects'],
  [ROUTE.models]: ['Models'],
  [ROUTE.tasks]: ['Tasks'],
  [ROUTE.members]: ['Members'],
  'task-detail': ['Tasks', 'Task Detail'],
  [ROUTE.embedded]: ['Embedded'],
} as const;

export const routeMenuItemsFooter = [
  {
    id: '1',
    label: 'Return to home',
    routerLink: '/',
    icon: 'home.svg',
  },
];

export const routeMenuItems = [
  {
    label: 'breadcrumb.overview',
    id: '1',
    initial: 'T',
    selected: false,
    routerLink: ['..'],
  },
  {
    label: 'breadcrumb.models',
    id: '2',
    initial: 'T',
    selected: false,
    routerLink: ['..', 'models'],
  },
  {
    label: 'breadcrumb.tasks',
    id: '3',
    initial: 'T',
    selected: false,
    routerLink: ['..', 'tasks'],
  },
  {
    label: 'breadcrumb.members',
    id: '4',
    initial: 'T',
    selected: false,
    routerLink: ['..', 'members'],
  },
];

/**
 * Same items as `routeMenuItems`, but with routerLinks relative to the project root
 * itself (e.g. used from the project overview page, which *is* the project route,
 * as opposed to `routeMenuItems` which is used from pages nested one level under it).
 * Derived from `routeMenuItems` to avoid duplication.
 */
export const projectRootMenuItems = routeMenuItems.map(item => ({
  ...item,
  routerLink:
    item.routerLink[0] === '..' && item.routerLink.length === 1 ? ['.'] : item.routerLink.slice(1),
}));
